module.exports = __webpack_public_path__ + "media/images/career_camp/2022/texts/step_3-d6e156275e8cc64da991138101a76196.svg";